import React, {useState, useRef, useContext, useMemo} from "react";
import {
  Button,
  Popper,
  Paper,
  IconButton, Tooltip
} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {AlertCircleIcon, ThumbsDownIcon, ThumbsUpIcon} from "@hugeicons/core-free-icons";
import {ConversationRepository} from "../../../../repositories/ConversationRepository";
import {SignInContext} from "../../../../context/SignInContext";
import {grey} from "@mui/material/colors";

export const LikePopoverButton = ({ conversation, updateConversation }) => {
  const {currentUser} = useContext(SignInContext)
  const [anchorEl, setAnchorEl] = useState(null);
  const timeoutRef = useRef(null);

  const currentLike = useMemo(() => {
    return conversation?.likes?.find(l => l?.username === currentUser?.username)
  }, [conversation?.likes, currentUser?.username]);


  const handleEnter = (event) => {
    clearTimeout(timeoutRef.current);
    setAnchorEl(event.currentTarget);
  };

  const handleLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setAnchorEl(null);
    }, 300);
  };

  const open = Boolean(anchorEl);

  const handleLike = (likeType) => {
    const username = currentUser?.username || null;
    if (currentLike?.id) {
      if (currentLike?.likeType === likeType) {
        //Delete
        ConversationRepository.removeLike({id: conversation?.id, likeId: currentLike?.id})
          .then(() => {
            updateConversation({...conversation, likes: [...(conversation?.likes || [])?.filter(i => i?.id !== currentLike?.id)]})
          })
          .catch(error => console.log(error))
      } else {
        // Change
        ConversationRepository.likeConversation({id: conversation?.id, username, likeType})
          .then(response => {
            updateConversation({...conversation, likes: [...(conversation?.likes || [])?.map(i => i?.id === currentLike?.id ? {...response?.data} : {...i})]})
          })
          .catch(error => console.log(error))
      }
    } else {
      // Change
      ConversationRepository.likeConversation({id: conversation?.id, username, likeType})
        .then(response => {
          updateConversation({...conversation, likes: [...(conversation?.likes || []), {...response?.data}]})
        })
        .catch(error => console.log(error))
    }
    // onLike(conversation.id, likeType);
    setAnchorEl(null);
  };


  const getButtonIcon = () => {
    switch (currentLike?.likeType) {
  case "LIKE": return <HugeiconsIcon icon={ThumbsUpIcon} size={16} />;
  case "DISLIKE": return <HugeiconsIcon icon={ThumbsDownIcon} size={16} />;
  case "ERROR": return <HugeiconsIcon icon={AlertCircleIcon} size={16} />;
  default: return <HugeiconsIcon icon={ThumbsUpIcon} size={16} />;
    }
  };

  const getButtonColor = () => {
    switch (currentLike?.likeType) {
      case "LIKE": return "success";
      case "DISLIKE": return "error";
      case "ERROR": return "warning";
      default: return "secondary";
    }
  };

  return (
    <div onMouseEnter={handleEnter} onMouseLeave={handleLeave}>
      <Tooltip title={conversation?.likes?.map(like => like?.username).join(", ") || "Like"} placement={"top-start"}>
        <Button
          startIcon={getButtonIcon()}
          color={getButtonColor()}
          sx={{color: currentLike?.likeType ? getButtonColor() : grey[600], textTransform: "capitalize"}}
        >
          {currentLike?.likeType?.toLowerCase() || "Like"}
        </Button>
      </Tooltip>

      <Popper open={open} anchorEl={anchorEl} placement="bottom-start" disablePortal sx={{zIndex: 1000}}>
        <Paper elevation={3} sx={{ zIndex: 1000, display: "flex", borderRadius: 3, p: 1, gap: 1 }}>
          <IconButton
            onClick={() => handleLike("LIKE")}
            color={currentLike?.likeType === "LIKE" ? "success" : "default"}
            title="Like"
          >
            {currentLike?.likeType === "LIKE" ? <HugeiconsIcon icon={ThumbsUpIcon} /> : <HugeiconsIcon icon={ThumbsUpIcon} />}
          </IconButton>
          <IconButton
            onClick={() => handleLike("DISLIKE")}
            color={currentLike?.likeType === "DISLIKE" ? "error" : "default"}
            title="Dislike"
          >
            {currentLike?.likeType === "DISLIKE" ? <HugeiconsIcon icon={ThumbsDownIcon} /> : <HugeiconsIcon icon={ThumbsDownIcon} />}
          </IconButton>
          <IconButton
            onClick={() => handleLike("ERROR")}
            color={currentLike?.likeType === "ERROR" ? "warning" : "default"}
            title="Error"
          >
            {currentLike?.likeType === "ERROR" ? <HugeiconsIcon icon={AlertCircleIcon} /> : <HugeiconsIcon icon={AlertCircleIcon} />}
          </IconButton>
        </Paper>
      </Popper>
    </div>
  );
};
